module.exports = __webpack_public_path__ + "img/ZWF_Hani_Chang.d3341ab3.jpg";